import axios from 'axios';
import { APP_CONFIG } from '@/constants/app';
import { tokenManager } from '@/utils/token-manager';

/** L'instance d'appel du module (jeton + organisation posés par l'intercepteur). */
export const api = axios.create({
  baseURL: APP_CONFIG.api.baseUrl,
  headers: { 'Content-Type': 'application/json' },
});
tokenManager.setupInterceptors(api);
